// Runtime-dependency-free on purpose: the config-less vitest run cannot
// resolve the "@/..." aliases at runtime, so this file has no imports.

// sinek answers at most this many coupons per GET /cashout-offers.
export const CASHOUT_OFFERS_MAX_COUPONS = 20;

export interface CashoutCandidate {
  id: string;
  // The coupon's state; only "open" coupons can have an offer.
  state: string;
  // Who placed it; sinek answers only for the player's own coupons.
  ownerId: number | undefined;
}

/** A player's own coupon (PlayerCoupon) as a candidate. */
export const toPlayerCashoutCandidate = (coupon: {
  id: string;
  state: string;
  userId: number;
}): CashoutCandidate => ({
  id: coupon.id,
  state: coupon.state,
  ownerId: coupon.userId,
});

/** A coupon-list row (Coupon), whose owner is `user`, as a candidate. */
export const toListCashoutCandidate = (coupon: {
  id: string;
  state: string;
  user?: { id: number } | null;
}): CashoutCandidate => ({
  id: coupon.id,
  state: coupon.state,
  ownerId: coupon.user?.id,
});

/**
 * The coupon ids worth asking an offer for: the viewer's own open coupons,
 * once each, sorted so the query key does not change with the list order.
 */
export const selectCashoutCouponIds = (
  coupons: CashoutCandidate[],
  viewerId: number
): string[] => {
  const ids = coupons
    .filter((coupon) => coupon.state === "open")
    .filter((coupon) => coupon.ownerId === viewerId)
    .map((coupon) => coupon.id);
  return [...new Set(ids)].sort();
};

/** Splits the ids into requests of at most `size` (the server's cap). */
export const chunkCouponIds = (
  ids: string[],
  size: number = CASHOUT_OFFERS_MAX_COUPONS
): string[][] => {
  const chunks: string[][] = [];
  for (let start = 0; start < ids.length; start += size) {
    chunks.push(ids.slice(start, start + size));
  }
  return chunks;
};
